var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUmansAiCodingPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Umans U logo icon",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "crosshatch",
    width: 6,
    height: 6,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6 l6,-6 M-1.5,1.5 l3,-3 M4.5,7.5 l3,-3",
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 l6,6 M-1.5,4.5 l3,3 M4.5,-1.5 l3,3",
    stroke: "currentColor",
    strokeWidth: 0.75
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 120,
    height: 120,
    rx: 15,
    ry: 15,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32, -5)   scale(0.70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 127C0 126.448 0.447715 126 1 126H19V163C19 163.552 18.5523 164 18 164H1C0.447715 164 0 163.552 0 163V127Z",
    fill: "url(#crosshatch)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 126H96C96.5523 126 97 126.448 97 127V163C97 163.552 96.5523 164 96 164H79C78.4477 164 78 163.552 78 163V126Z",
    fill: "url(#crosshatch)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9268 108.694C18.9268 108.034 19.7126 107.5 20.3456 107.5H76.3678C77.0008 107.5 78.0732 108.047 78.0732 108.707V126C77.6789 126 77.8739 126 77.2409 126H18.9268C18.9268 125.5 19.3211 126 18.9268 126V108.694Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 90.1935C0 89.5344 0.513186 89 1.14623 89H18.1965C18.8295 89 19 89.3408 19 90L18.9268 106.293C18.9268 106.953 18.8295 107.5 18.1965 107.5H1.14623C0.513186 107.5 0 106.966 0 106.306V90.1935Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 90C78 89.3408 78.1705 89 78.8036 89H95.8538C96.4868 89 97 89.5344 97 90.1935V106.306C97 106.966 96.4868 107.5 95.8538 107.5H78.8036C78.1705 107.5 78.0732 106.908 78.0732 106.249L78 90Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9268 109.109C18.9268 107.676 18.1382 107.5 16.692 107.5L17.3368 106.232C17.886 105.411 18.9268 103.88 18.9268 105.087C18.9268 106.696 19.7154 107.5 21.2053 107.5L20.8471 108.246L20.2024 109.141L18.9268 109.109Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0732 109.511C78.0732 107.902 78.8036 107.5 80.2363 107.5L79.5609 106.249C78.9855 105.394 78.0662 103.685 78.0732 105.087C78.0803 106.524 77.2846 107.5 75.5798 107.5L75.8834 108.346L76.5588 109.278L78.0732 109.511Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 44C0 43.4477 0.447715 43 1 43H18C18.5523 43 19 43.4477 19 44V92H0V44Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 44C78 43.4477 78.4477 43 79 43H96C96.5523 43 97 43.4477 97 44V92H78V44Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmansAiCodingPlan);
export default __webpack_public_path__ + "static/media/umans-ai-coding-plan.75a9e24571c7fa1dc27e7190843e3d51.svg";
export { ForwardRef as ReactComponent };